<template>
    <div class="sign-sale">
        <div class="sign-sale-input-texts">
            <div class="he">
                <el-input size="mini" :input-style="input_style" style="width:100%;" v-if="!is_sales_print"
                    v-model="clone_sign.RemarkForPrint" maxlength="35" placeholder="שם המוצר בעברית" />
                <h1 v-if="is_sales_print" class="sign-name" :class="name_class">{{ clone_sign?.RemarkForPrint }}</h1>
                <i v-if="is_catalog_signs" @click="handle_show_items_list"
                    class="material-icons float-icon add-icon">add</i>
            </div>
        </div>
        <div v-if="!is_catalog_signs" class="sign-sale-contents">
            <div class="col">
                <el-input size="mini" :input-style="input_style" type="number" v-if="!is_sales_print"
                    v-model="clone_sign.amount" placeholder="הזן מספר" />
                <h1 v-if="is_sales_print && Number(sign?.amount) > 0.01">{{ clone_sign.amount }} <span class="unit">יח'</span></h1>
                <h1 v-else-if="is_sales_print && Number(sign?.amount) < 1">{{ clone_sign.amount }} <span class="unit">ק"ג</span></h1>
            </div>
            <div class="col small">
                <h1>ב</h1>
            </div>
            <div class="col">
                <el-input size="mini" :input-style="input_style" type="number" v-if="!is_sales_print"
                    v-model="clone_sign.sum_price" placeholder="הזן מספר" />
                <h1 v-if="is_sales_print">{{ clone_sign.sum_price }}<span class="shekel"> &#8362;</span></h1>
            </div>
        </div>
        <div v-else class="sign-sale-contents catalog">
            <div v-if="!is_sales_print" class="col-2 col">
                <el-input size="mini" :input-style="input_style" type="number" v-model="clone_sign.price"
                    placeholder="מחיר" />
            </div>
            <div v-if="!is_sales_print" class="col-1 col">
                <h1>ל-</h1>
            </div>
            <div v-if="!is_sales_print" class="col-2 col">
                <el-input size="mini" :input-style="input_style" v-model="clone_sign.unit"
                    placeholder="הזן יחידת מידה" />
            </div>
            <h1 v-if="is_sales_print">
                {{ clone_sign.price }} &#8362; <span>ל - {{ clone_sign.unit }}</span>
            </h1>
        </div>
        <div v-if="clone_sign?.products?.length > 0" class="sign-sale-footer">
            <div v-if="!is_catalog_signs" class="col price">
                <el-input size="mini" v-if="!is_sales_print" :input-style="{ ...input_style, 'color': '#333' }"
                    v-model="clone_sign.original_price" placeholder="מחיר רגיל ליח' או ל100 גר'" />
                <small v-else>מחיר רגיל: {{ clone_sign.original_price }} &#8362;</small>
            </div>
            <div v-if="!is_catalog_signs && limit_text" class="prormo-limit" :class="limit_class">
                <p>{{ limit_text }}</p>
            </div>
            <div class="col barcodes">
                <h1 data-fixed>
                    * לחברי מועדון בלבד, ברקוד:
                </h1>
                <h1 data-slice v-if="clone_sign?.Items?.length > 0">
                    {{ clone_sign.products.slice(0, 6).map(product => product.barcode.slice(-5)).join(",") +
                        (clone_sign.products.length > 6 ? '...' : '') }}
                </h1>
                <h1 data-slice v-if="clone_sign?.barcode">
                    {{ clone_sign?.barcode.slice(-5) }}
                </h1>
            </div>
        </div>
        <div v-else class="sign-sale-footer item-error">
            <h1>פריט לא הוקם טוב בקומקס נא לפנות למחלקת סחר</h1>
        </div>
        <div v-if="show_items_list" class="choos-item slide-in-top">
            <ItemsList @back="show_items_list = false; clone_sign = {};" @item_choosen="handle_item_choosen" />
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { computed, defineAsyncComponent } from 'vue'
import { is_sales_print } from '../../Scripts/scripts'
import { is_catalog_signs, printer_amount, is_deleted } from '../../components/Deals/Scripts/store'

/*
    שלט בודד עבור עשיריית שלטים מבצע חם.
    כפתורי השכפול/המחיקה מוצגים ע"י דף העשירייה (BlankPageSalesTen) באזור השמור העליון,
    ולכן אין כאן שורת כותרת - כל הגובה של השלט מוקדש לתוכן.
    גדלי הגופנים מדורגים לפי אורך הטקסט כדי שהתוכן לא יחרוג מגבולות השלט.
*/
export default {
    components: {
        ItemsList: defineAsyncComponent(() => import('../../ItemsList.vue')),
    },
    props: ['sign'],
    setup(props) {

        const show_items_list = ref(false)

        const clone_sign = ref({})

        const input_style = ref({
            'font-size': '14px',
            'height': '24px',
            'line-height': '24px',
            'color': 'black',
            'text-align': 'center',
            'border': '2px solid black',
            'border-left': '0',
            'border-right': '0',
            'border-top': '0',
        })

        // שם המוצר: עד 18 תווים בגופן הגדול, מעבר לכך מוקטן בהדרגה (עד 2 שורות)
        const name_class = computed(() => {
            const len = (clone_sign.value?.RemarkForPrint || '').trim().length
            if (len > 26) return 'name-tier-3'
            if (len > 18) return 'name-tier-2'
            return ''
        })

        const limit_text = computed(() =>
            (clone_sign.value?.limitations || [])
                .filter(lim => lim && lim.trim() && lim != 'לחברי מועדון בלבד')
                .join(', ')
        )

        // מגבלות המבצע: שורה אחת בלבד, הגופן מוקטן ככל שהטקסט מתארך
        const limit_class = computed(() => {
            const len = limit_text.value.length
            if (len > 60) return 'pl-tier-4'
            if (len > 45) return 'pl-tier-3'
            if (len > 30) return 'pl-tier-2'
            return ''
        })

        const handle_show_items_list = () => {
            show_items_list.value = true
        }

        const handle_item_choosen = (item) => {
            show_items_list.value = false
            clone_sign.value = {
                RemarkForPrint: item.Name,
                barcode: item.barcode,
                price: item.amount == '0.01' ? (Number(item?.price) / 10).toFixed(2) : item?.price,
                amount: item.amount,
                unit: item.amount == '0.01' ? '100 גרם' : 'יח\''
            }
        }

        const init = () => {
            if (props.sign) {
                clone_sign.value = JSON.parse(JSON.stringify(props.sign))
                clone_sign.value.original_price = clone_sign?.value?.products?.[0]?.price;
                if (Number(props.sign.amount) < 1) {
                    clone_sign.value.amount = Number(props.sign.amount * 100)
                    clone_sign.value.sum_price = (Number(clone_sign.value.sum_price)).toFixed(2)
                }
                if (!is_catalog_signs.value && !is_deleted.value) {
                    printer_amount.value.push(1)
                }
            }
        }

        init()

        return {
            input_style,
            clone_sign,
            is_sales_print,
            is_catalog_signs,
            show_items_list,
            handle_show_items_list,
            handle_item_choosen,
            name_class,
            limit_text,
            limit_class,
        }
    }
}
</script>

<style scoped>
/* תצוגה מקדימה - אותם יחסי גובה כמו בהדפסה: שם 38%, כמות ומחיר 28%, תחתית 34% */
.sign-sale {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.sign-sale h1,
.sign-sale p {
    margin: 0;
}

.sign-sale-input-texts {
    position: relative;
    width: 100%;
    height: 38%;
    overflow: hidden;
}

.sign-sale-input-texts .he {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 3px;
    overflow: hidden;
}

.sign-name {
    font-weight: 700;
    font-size: 24px;
    line-height: 1.1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
}

.sign-name.name-tier-2 {
    font-size: 22px;
}

.sign-name.name-tier-3 {
    font-size: 20px;
}

.float-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
}

.add-icon {
    color: var(--success);
    cursor: pointer;
    font-size: 24px;
    user-select: none;
}

.sign-sale-contents {
    width: 100%;
    height: 28%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    overflow: hidden;
}

.sign-sale-contents .col {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.sign-sale-contents .col:not(.small) {
    flex: 1 1 0;
    min-width: 0;
}

.sign-sale-contents .col h1 {
    font-size: 26px;
    font-weight: 700;
}

.sign-sale-contents .col.small h1 {
    font-size: 18px;
    font-weight: 500;
}

.unit {
    font-size: 14px;
}

.shekel {
    font-size: 18px;
}

.sign-sale-contents.catalog .col-1 {
    flex: 0 0 10%;
}

.sign-sale-contents.catalog .col-2 {
    flex: 0 0 45%;
}

.sign-sale-contents.catalog h1 {
    font-size: 18px;
}

.sign-sale-footer {
    width: 100%;
    height: 34%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1px;
    padding: 0 3px;
    overflow: hidden;
}

.sign-sale-footer.item-error {
    color: red;
    font-size: 11px;
    text-align: center;
}

.col.price {
    width: 100%;
    display: flex;
    justify-content: center;
}

.col.price > small {
    font-weight: 500;
    font-size: 12px;
    line-height: 1.15;
    white-space: nowrap;
}

.prormo-limit {
    width: 100%;
    display: flex;
    justify-content: center;
    overflow: hidden;
}

.prormo-limit p {
    font-weight: 500;
    font-size: 10px;
    line-height: 1.15;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.prormo-limit.pl-tier-2 p {
    font-size: 9px;
}

.prormo-limit.pl-tier-3 p {
    font-size: 8px;
}

.prormo-limit.pl-tier-4 p {
    font-size: 7px;
}

.col.barcodes {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 3px;
    white-space: nowrap;
    overflow: hidden;
}

.col.barcodes h1 {
    font-size: 9px;
    font-weight: 500;
    line-height: 1.15;
}

[data-slice] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

[data-fixed] {
    display: flex;
    align-items: center;
}

.choos-item {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--main);
    z-index: 1000;
}
</style>
